export default __webpack_public_path__ + "static/media/Shadowcord.06c277f0.jpg";